import { stringIncludes } from '@aibees/shared/utils/string';
import { times } from 'lodash-es';

export function repeat(value: any, count = 1) {
  return times(count ?? 1, () => value);
}

/*
  Sorts an array of objects based on another array order
*/
export function mapOrder(
  array: any[],
  orderArray: any[],
  orderKey: string,
  defaultValue?: number
) {
  array.sort((a, b) => {
    const A = a[orderKey];
    const B = b[orderKey];
    if (orderArray.indexOf(B) === -1) return defaultValue ?? -1;
    if (orderArray.indexOf(A) > orderArray.indexOf(B)) {
      return 1;
    }
    return -1;
  });

  return array;
}

export const arraysAreEqual = (arr1: string[], arr2: string[]) => {
  // Check if both arrays have the same length
  if (arr1.length !== arr2.length) {
    return false;
  }
  // Check if every element in arr1 matches the corresponding element in arr2
  return arr1.every((element, index) => element === arr2[index]);
};

/**
 * Check if two arrays have the same elements, ignoring order
 */
export const haveSameElements = (arr1: string[], arr2: string[]): boolean => {
  if (arr1.length !== arr2.length) return false;
  const sorted1 = [...arr1].sort();
  const sorted2 = [...arr2].sort();
  return sorted1.every((item, index) => item === sorted2[index]);
};

/**
 * Check if two arrays have the same elements in the same order
 */
export const areArraysEqualWithOrder = (
  arr1: string[],
  arr2: string[]
): boolean => {
  if (arr1.length !== arr2.length) return false;
  return arr1.every((item, index) => item === arr2[index]);
};

export const splitArrayInHalf = <T>(arr: T[]): [T[], T[]] => {
  const midIndex: number = Math.ceil(arr.length / 2);
  const firstHalf: T[] = arr.slice(0, midIndex);
  const secondHalf: T[] = arr.slice(midIndex);

  return [firstHalf, secondHalf];
};

export function searchArrayOfObjects<T extends Record<string, any>>(
  arr?: T[],
  key?: string,
  keyword?: string
): T[] {
  if (!keyword || !arr || !keyword?.length || !key) return arr ?? [];
  return arr.filter((x) => stringIncludes(x[key] as string, keyword));
}

export function searchArrayOfStrings(
  arr?: string[],
  keyword?: string
): string[] {
  if (!keyword || !arr || !keyword?.length) return arr ?? [];
  return arr.filter((x) => stringIncludes(x, keyword));
}

export function findNearestOption(num: number, arr: number[]) {
  arr.sort((a, b) => a - b);
  for (let i = 0; i < arr.length - 1; i++) {
    if (num > arr[i] && num < arr[i + 1]) {
      return arr[i + 1];
    }
  }
  return null;
}
